<template>
    <div class="vue-drupal-view-filters-wrapper dropdown-filters-wrapper">
        <template v-if="loading">
            <span class="is-loading">{{ translations.loading }}</span>
        </template>

        <div class="filter-components-wrapper">
            <div class="form-checkboxes" v-if="events">
                <div class="form-check form-item form-type-checkbox">
                    <input type="checkbox" id="filterTypeOnce" v-model="filterTypeOnce" @click="typeClicked('once')">
                    <label class="form-check-label" for="filterTypeOnce">
                        {{ translations.typeOnce }}
                    </label>
                </div>

                <div class="form-check form-item form-type-checkbox">
                    <input type="checkbox" id="filterTypeLonglasting" v-model="filterTypeLonglasting"
                           @click="typeClicked('longlasting')">
                    <label class="form-check-label" for="filterTypeLonglasting">
                        {{ translations.typeLonglasting }}
                    </label>
                </div>
            </div>

            <ef2-calendar-filter
                v-if="!isLocationPage"
                :place-holder="translations.selectDates"
                @filter-changed="handleFilterChanged"
            ></ef2-calendar-filter>

            <ef2-drupal-view-filter-dropdown
                :items="filterData.places"
                :slug="filterData.places_slug"
                :preSelected="filterData.selected_places"
                :label="translations.placeNames"
                :is-result-page="isResultPage"
                :is-location-page="isLocationPage"
                @filter-changed="handleFilterChanged"
            ></ef2-drupal-view-filter-dropdown>

            <ef2-drupal-view-filter-dropdown
                :items="filterData.categories"
                :slug="filterData.categories_slug"
                :preSelected="filterData.selected_categories"
                :label="translations.category"
                :is-result-page="isResultPage"
                :is-location-page="isLocationPage"
                @filter-changed="handleFilterChanged"
            ></ef2-drupal-view-filter-dropdown>

            <ef2-drupal-view-filter-dropdown
                v-if="filterData.properties_slug && filterData.properties"
                :items="filterData.properties"
                :slug="filterData.properties_slug"
                :preSelected="filterData.selected_properties"
                :label="translations.characteristics"
                :is-result-page="isResultPage"
                :is-location-page="isLocationPage"
                @filter-changed="handleFilterChanged"
            ></ef2-drupal-view-filter-dropdown>

            <slot></slot>

            <div class="button-wrapper">
                <button @click="handleReset" class="cta-link reset-btn">{{ translations.removeFilters }}</button>

                <button @click="handleFilter" class="btn-secondary filter-btn">{{ translations.applyFilters }}</button>
            </div>
        </div>


    </div>
</template>

<script>
export default {
    name: "DrupalViewFiltersWrapper",

    props: {
        filterData: {},
        currentUrl: {},
        events: {
            type: Boolean,
            default: false
        },
        isResultPage: {
            type: Boolean,
            default: false,
        },
        isLocationPage: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            selectedPlaces: null,
            selectedCategories: null,
            selectedProperties: null,
            selectedDates: null,
            loading: false,
            filterTypeLonglasting: true,
            filterTypeOnce: true,
            translations: {
                removeFilters: window.Drupal.t('Remove filters'),
                applyFilters: window.Drupal.t('Search'),
                category: window.Drupal.t('Category'),
                characteristics: window.Drupal.t('Characteristics'),
                placeNames: window.Drupal.t('Place names'),
                selectDates: window.Drupal.t('Select the dates'),
                typeOnce: window.Drupal.t('One time'),
                typeLonglasting: window.Drupal.t('Long lasting'),
                loading: window.Drupal.t('Loading'),
            }
        }
    },

    mounted() {
        if (!_.isEmpty(this.filterData.selected_types)) {
            if (this.filterData.selected_types === 'one-time') {
                this.filterTypeLonglasting = false;
            } else {
                this.filterTypeOnce = false;
            }
            console.log(this.filterData.selected_types);
        }
    },

    computed: {
        computedSearchParams() {
            let params = new URLSearchParams();

            if (!_.isNil(this.selectedDates)) {
                params.append('startDate', this.selectedDates.startDate)
                params.append('endDate', this.selectedDates.endDate)
            }

            _.forEach(this.selectedPlaces, (item) => {
                if (this.isResultPage || this.isLocationPage) {
                    params.append(`${this.filterData.places_slug}[${item}]`, item)
                    return;
                }
                params.append(`${this.filterData.places_slug}[]`, item)
            });

            _.forEach(this.selectedCategories, (item) => {
                if (this.isResultPage || this.isLocationPage) {
                    params.append(`${this.filterData.categories_slug}[${item}]`, item)
                    return;
                }
                params.append(`${this.filterData.categories_slug}[]`, item)
            });

            _.forEach(this.selectedProperties, (item) => {
                params.append(`${this.filterData.properties_slug}[${item}]`, item)
            });

            if (!this.filterTypeOnce || !this.filterTypeLonglasting) {
                if (this.filterTypeOnce) {
                    params.append('type', 'one-time');
                }
                if (this.filterTypeLonglasting) {
                    params.append('type', 'long-lasting');
                }
            }

            if (this.hasFilters) {
                return `${this.currentUrl}?${decodeURI(params.toString())}`;
            }

            return `${this.currentUrl}`;
        },

        hasFilters() {
            return !_.isEmpty(this.selectedCategories) || !_.isEmpty(this.selectedPlaces)
                || !_.isNil(this.selectedDates) || !_.isNil(this.selectedProperties)
                || (!this.filterTypeOnce || !this.filterTypeLonglasting)
        }
    },

    methods: {
        typeClicked(value) {
            if (value === 'once') {
                this.filterTypeOnce = !this.filterTypeOnce;
            }
            if (value === 'longlasting') {
                this.filterTypeLonglasting = !this.filterTypeLonglasting;
            }
        },

        handleFilterChanged(payload) {
            if (payload.slug === 'places') {
                this.selectedPlaces = payload.items
                return;
            }

            if (payload.slug === 'categories') {
                this.selectedCategories = payload.items
                return
            }

            if (payload.slug === 'properties') {
                this.selectedProperties = payload.items
                return
            }

            //calendar filter
            this.selectedDates = payload.items;
        },

        handleFilter() {
            this.loading = true;
            window.open(this.computedSearchParams, '_self')
        },

        handleReset() {
            this.loading = true;
            window.open(this.currentUrl, '_self')
        }
    }
}
</script>